import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { BuilderHotelRoom } from 'app/typings/core/builder/rooms';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useBuilderHotelRooms(hotelId?: number) {
  return useQuery<BuilderHotelRoom[] | null>({
    queryKey: [CORE_QUERY_KEYS.builderRooms, { id: hotelId }],
    queryFn: () =>
      hotelId
        ? (apiRequest({
            path: ENDPOINTS.getRooms,
            params: { id: hotelId.toString() },
          }) as Promise<BuilderHotelRoom[]>)
        : Promise.resolve(null),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
  });
}
